<template>
  <prime-accordion v-if="available && (clientId || representativeId)" @tab-open="loadDocuments">
    <prime-accordion-tab header="File da cambio rappresentante">
      <p v-if="loading">Caricamento documenti...</p>
      <p v-else-if="error" class="p-error">{{ error }}</p>
      <p v-else-if="!documents.length">Nessun documento di nomina da cambio rappresentante.</p>
      <div v-else class="flex flex-wrap gap-2">
        <div v-for="documento in documents" :key="documento.id" class="p-3 border-1 border-round surface-border">
          <div><strong>{{ documento.tipo_documento || `Documento ${documento.id}` }}</strong></div>
          <small>{{ formatDocumentDate(documento.data_inserimento) }}</small>
          <div v-if="clientId && documento.rappresentante_id">
            Rappresentante:
            <router-link :to="`/ask/rappresentanti/${documento.rappresentante_id}/dettagli`">
              {{ documento.rappresentante || `ID ${documento.rappresentante_id}` }}
            </router-link>
          </div>
          <div v-if="representativeId">
            Clienti:
            <template v-if="documento.clienti && documento.clienti.length">
              <template v-for="(cliente, index) in documento.clienti" :key="cliente.id">
                <span v-if="index">, </span><router-link :to="`/ask/clienti/${cliente.id}/dettagli`">{{ cliente.ragsoc || `ID ${cliente.id}` }}</router-link>
              </template>
            </template>
            <span v-else>nessuno associato</span>
          </div>
          <prime-button class="block mt-2" label="Visualizza" icon="pi pi-eye" :disabled="opening === documento.id" @click="openDocument(documento)" />
        </div>
      </div>
    </prime-accordion-tab>
  </prime-accordion>
</template>

<script>
import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeButton from 'primevue/button'
import moment from 'moment'
import RepresentativeDocumentsService from '@/services/ask-pratiche/representative-documents-service'

export default {
  components: { PrimeAccordion, PrimeAccordionTab, PrimeButton },
  props: {
    available: { type: Boolean, default: false },
    clientId: { type: [Number, String], default: null },
    representativeId: { type: [Number, String], default: null }
  },
  data() {
    return { documents: [], loading: false, error: '', opening: null }
  },
  methods: {
    formatDocumentDate(value) {
      if (!value) return ''
      const date = moment(value)
      return date.isValid() ? date.format('DD/MM/YYYY, HH:mm') : value
    },
    async loadDocuments() {
      if (this.loading) return
      const service = new RepresentativeDocumentsService(this.$http)
      service.setAvailable(this.available)
      this.loading = true
      this.error = ''
      try {
        const rows = this.clientId
          ? await service.getClientNominations(this.clientId)
          : await service.getRepresentativeDocuments(this.representativeId)
        this.documents = this.clientId ? rows : rows.filter(row => row.ref === 'nom')
      } catch (error) {
        this.error = 'Impossibile caricare i file da cambio rappresentante.'
      } finally {
        this.loading = false
      }
    },
    async openDocument(documento) {
      const service = new RepresentativeDocumentsService(this.$http)
      service.setAvailable(this.available)
      this.opening = documento.id
      try {
        if (this.clientId) await service.openClientNomination(this.clientId, documento.id)
        else await service.openRepresentativeDocument(this.representativeId, documento.id)
      } catch (error) {
        this.$eventBus.emit('data-load-error', { message: 'Impossibile visualizzare il documento.' })
      } finally {
        this.opening = null
      }
    }
  }
}
</script>
